// deps - BetterAjax

var PwnageCardsController = {
  data: {},
  init: function (noAjax = false) {
    this.data.cardsEls = document.querySelectorAll(".accessories article")
    this.cards = []
    this.noAjax = noAjax
    this.data.cardsEls.forEach((cardEl) => {
      this.cards.push(new PwnageCard(cardEl))
    })
  },
}

class PwnageCard {
  constructor(cardEl) {
    this.cardEl = cardEl
    this.cardImageEl = cardEl.querySelector(".product-card__variant-image")
    this.cardOptionsEl = cardEl.querySelector(".product-card__variant-select")
    this.cardPriceEl = cardEl.querySelector(".card__price")
    this.cardCompareAtPriceEl = cardEl.querySelector(".card__compare-at-price")
    this.formEl = cardEl.querySelector("form")

    this.bindUIAction()
  }

  bindUIAction() {
    if (this.cardOptionsEl) {
      this.cardOptionsEl.addEventListener("change", (event) => {
        var selectedOptionEl =
          this.cardOptionsEl.options[this.cardOptionsEl.selectedIndex]
        this.cardImageEl.src = selectedOptionEl.dataset.image
        // TODO set backorder notification
        this.cardPriceEl.innerHTML = Shopify.formatMoney(
          selectedOptionEl.dataset.price,
          ""
        )
        this.cardCompareAtPriceEl.innerHTML =
          selectedOptionEl.dataset.compareAtPrice == 0
            ? ""
            : Shopify.formatMoney(
                selectedOptionEl.dataset.compareAtPrice,
                ""
              )
      })

      if (!PwnageCardsController.noAjax) {
        this.formEl.addEventListener("submit", (event) => {
          event.preventDefault()
          new BetterAJAX(
            [
              this.cardOptionsEl.options[this.cardOptionsEl.selectedIndex]
                .dataset.image,
            ],
            [this.cardOptionsEl.value],
            [1]
          )
        })
      }
    } else if (!PwnageCardsController.noAjax) {
      this.formEl.addEventListener("submit", (event) => {
        event.preventDefault()
        new BetterAJAX(
          [this.formEl.dataset.image],
          [this.formEl.elements["id"].value],
          [1]
        )
      })
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelectorAll(".accessory__add-to-cart").length) {
    PwnageCardsController.init()
  }
})
